import "./DeviceReviews.module.css";
import Header from "@/reusable_sections/Header";
import OurInventory from "./sections/OurInventory";
import LatestGuides from "./sections/LatestGuides";
import FromTheWritingDesk from "./sections/FromTheWritingDesk";
import ClimateWindowCoveringsReviews from "./sections/ClimateWindowCoveringsReviews";
import Footer from "@/reusable_sections/Footer";
export default function DeviceReviewsPage() {
  return <div>
      <Header />
      <OurInventory />
      <LatestGuides />
      <FromTheWritingDesk />
      <ClimateWindowCoveringsReviews />
      <Footer />
    </div>;
}